import { useDispatch, useSelector } from 'app-redux'
import { ScriptDetails } from 'features/script'
import UserChat from 'messaging/chat'
import {
	MiscSelectedSelectedItem,
	setMiscPanelOpen,
	setMiscPanelSelectedItem,
} from 'room/common/redux'
import { PanelLayout, PanelTab } from './presentation/chrome'

/**
 * Chat, agenda and boardlet: the desktop `room.miscPanel` state with a phone
 * layout (the desktop drawer is 500-1000px wide). The contents are the same
 * components and web components, unchanged.
 */
export const ConfiguredPanel = (): JSX.Element | null => {
	const dispatch = useDispatch()
	const training = useSelector(state => state.sessionInfo.training)
	const selected = useSelector(state => state.room.miscPanel.selectedItem)

	if (!training) {
		return null
	}

	const tabs: PanelTab<MiscSelectedSelectedItem>[] = [
		{ id: MiscSelectedSelectedItem.Messages, label: 'lobby.misc.messages' },
		{ id: MiscSelectedSelectedItem.Agenda, label: 'lobby.misc.agenda' },
	]
	if (training.feedType) {
		tabs.push({
			id: MiscSelectedSelectedItem.Boardlet,
			label: `lobby.misc.${training.feedType}`,
		})
	}

	// A boardlet selected for a training without one would render nothing.
	const shown =
		selected === MiscSelectedSelectedItem.Boardlet && !training.feedType
			? MiscSelectedSelectedItem.Messages
			: selected

	return (
		<PanelLayout
			tabs={tabs}
			selected={shown}
			onSelect={item => dispatch(setMiscPanelSelectedItem(item))}
			onClose={() => dispatch(setMiscPanelOpen(false))}
		>
			{shown === MiscSelectedSelectedItem.Messages ? (
				<UserChat training={training} />
			) : null}
			{shown === MiscSelectedSelectedItem.Agenda ? <ScriptDetails /> : null}
			{shown === MiscSelectedSelectedItem.Boardlet && training.feedType ? (
				<beelday-training-feed
					trainingId={training.id}
					trainerId={training.upperEchelon.userId}
					feedType={training.feedType}
					style={{ display: 'flex', flex: 1, minHeight: 0 }}
				/>
			) : null}
		</PanelLayout>
	)
}

export default ConfiguredPanel
